import { requestHelpers } from '../../helpers';
import { updateTodoList } from '../todo_list/todo_list';

const actions = {
    GET_FORUM_CATEGORIES: 'GET_FORUM_CATEGORIES',
    SET_FORUM_CATEGORIES: 'SET_FORUM_CATEGORIES',
    GET_FORUM_THREADS: 'GET_FORUM_THREADS',
    SET_FORUM_THREADS: 'SET_FORUM_THREADS',
    GET_CURRENT_THREAD: 'GET_CURRENT_THREAD',
    SET_CURRENT_THREAD: 'SET_CURRENT_THREAD',
    GET_THREAD_POSTS: 'GET_THREAD_POSTS',
    SET_THREAD_POSTS: 'SET_THREAD_POSTS',
    SET_STATUS: 'SET_STATUS',
    RESET_STATUS: 'RESET_STATUS',
};

function getCategories(product_id, page) {
    return (dispatch) => {
        dispatch({
            type: actions.GET_FORUM_CATEGORIES,
            product_id,
        });

        requestHelpers
            .authenticatedGetRequest(`/forums/${product_id}/categories`, { page })
            .then((response) => {
                dispatch({
                    type: actions.SET_FORUM_CATEGORIES,
                    categories: response.data,
                    pagination: response.meta,
                });
            });
    };
}

function getThreads(page, categoryId) {
    return (dispatch) => {
        dispatch({
            type: actions.GET_FORUM_THREADS
        });

        requestHelpers
            .authenticatedGetRequest(`/forums/categories/${categoryId}/threads`, { page })
            .then((response) => {
                dispatch({
                    type: actions.SET_FORUM_THREADS,
                    threads: response.data,
                    pagination: response.meta,
                });
            });
    };
}

function createThread(categoryId, thread, personId) {
    return (dispatch) => {
        requestHelpers
            .authenticatedPostRequest(`/forums/categories/${categoryId}/threads`, thread)
            .then((response) => {
                dispatch({
                    type: actions.SET_STATUS,
                    success: response.success,
                });
            })
            .catch((error) => {
                console.log(`Error:\n${error}`);
            });
        dispatch(updateTodoList(personId, 5));
    };
}

function resetStatus() {
    return (dispatch) => {

        dispatch({
            type: actions.RESET_STATUS,
            success: false,
        });

    }
}

function getCurrentThread(threadId) {
    return (dispatch) => {
        dispatch({
            type: actions.GET_CURRENT_THREAD
        });

        requestHelpers
            .authenticatedGetRequest(`/forums/threads/${threadId}`)
            .then((response) => {
                dispatch({
                    type: actions.SET_CURRENT_THREAD,
                    current_thread: response.data,
                    person: response.data.person_id,
                });
            });
    };
}

function getThreadPosts(threadId, page) {
    return (dispatch) => {
        dispatch({
            type: actions.GET_THREAD_POSTS,
            threadId,
        });

        requestHelpers
            .authenticatedGetRequest(`/forums/threads/${threadId}/posts`, { page })
            .then((response) => {
                dispatch({
                    type: actions.SET_THREAD_POSTS,
                    posts: response.data,
                    pagination: response.meta
                });
            });
    };
}

function replyToThread(threadId, post) {
    return (dispatch) => {
        requestHelpers
            .authenticatedPostRequest(`/forums/threads/${threadId}/posts`, post)
            .then((response) => {
                dispatch({
                    type: actions.SET_STATUS,
                    success: response.success,
                });
            })
            .catch((error) => {
                console.log(`Error: ${error}`);
            });

        dispatch(updateTodoList(localStorage.getItem('person_id'), 5));
    }
}

module.exports = {
    actions,
    getCategories,
    getThreads,
    createThread,
    getCurrentThread,
    getThreadPosts,
    replyToThread,
    resetStatus,
};



// WEBPACK FOOTER //
// src/client/actions/forums/forums.js